module.exports = __webpack_public_path__ + "img/about_office_10.63daf2fd.jpg";